import { render } from "./Mural.vue?vue&type=template&id=d32333c2&scoped=true"
import script from "./Mural.vue?vue&type=script&lang=js"
export * from "./Mural.vue?vue&type=script&lang=js"

import "./Mural.vue?vue&type=style&index=0&id=d32333c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32333c2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBreadcrumbs,QBreadcrumbsEl});
